import { matchPath } from "react-router-dom";
import { UpdateActiveTab } from "../../reducers/trade_details_Slice";

export const PAGE_CONFIG = [
  {
    match: (path: string) => path === "/customers",
    activeTab: "customers",
    title: "Customers",
  },

  {
    match: (path: string) => matchPath("/customer-details/:mosId", path),
    activeTab: "customers",
    title: (path: string) => {
      const id = path.split("/")[2];
      return `Customers | mOS ID: ${id}`;
    },
  },

  {
    match: (path: string) => path === "/trades",
    activeTab: "trades",
    title: "Trades",
    onEnter: (dispatch: any) => dispatch(UpdateActiveTab("Open Trades")),
  },

  {
    match: (path: string) =>
      matchPath("/trade-detail/:traderId/:tradeId", path),
    activeTab: "trades",
    title: "Trades",
  },

  {
    match: (path: string) => matchPath("/supply-details/:postId", path),
    activeTab: "trades",
    title: (path: string) => {
      const id = path.split("/")[2];
      return `Trades | Supply Post ID: ${id}`;
    },
  },

  {
    match: (path: string) => matchPath("/demand-details/:postId", path),
    activeTab: "trades",
    title: (path: string) => {
      const id = path.split("/")[2];
      return `Trades | Demand Post ID: ${id}`;
    },
  },

  {
    match: (path: string) => path === "/loans",
    activeTab: "loans",
    title: "Loans",
  },

  {
    match: (path: string) => path === "/payments",
    activeTab: "payments",
    title: "Payments",
  },

  {
    match: (path: string) => path.startsWith("/reports"),
    activeTab: "reports",
    title: "Reports",
  },

  {
    match: (path: string) => path === "/markets",
    activeTab: "markets",
    title: "Markets",
  },

  {
    match: (path: string) => path === "/partners",
    activeTab: "partners",
    title: "Partners",
  },

  {
    match: (path: string) => path === "/risk-engine",
    activeTab: "risk_engine",
    title: "Risk Engine",
  },

  {
    match: (path: string) => matchPath("/risk-engine/composition", path),
    activeTab: "risk_engine",
    title: "Composition",
  },

  {
    match: (path: string) => path === "/price-prediction",
    activeTab: "price_prediction",
    title: "Price Prediction",
  },

  {
    match: (path: string) => path === "/my-profile",
    activeTab: "my_profile",
    title: "My Profile",
  },
];
